<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="table-layout">
            <el-table :data="dataList" border style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
                <el-table-column width="55" fixed="left" v-if="radioFlag">
                    <template slot-scope="rows">
                        <div class="copy-radio ml15" :class="{'circle' : selectTpl!= null && selectTpl.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="55" align="center" v-if="!radioFlag" type="selection"></el-table-column>
                <el-table-column width="150" prop="confName" label="职责权限名称"></el-table-column>
                <el-table-column width="150" prop="realName" label="目标岗位名称"></el-table-column>
                <el-table-column prop="desc" label="描述"></el-table-column>
                <el-table-column prop="mobAppRoleName" label="移动端角色" width="140"></el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="300">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="showRoleRescDlg(rows.row.id)">查看岗位资源</div>
                        <div class="swb-btn swb-btn-link" @click="showBusinessSetDlg(rows.row.id)">查看业务设置</div>
                        <div class="swb-btn swb-btn-link" @click="appResc(rows.row)" v-if="rows.row.mobAppRoleCode != null">查看移动端资源</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'

    import merchtAllApi from '../../api/merchtAll'

    import SwbTplComRoleRescList from './TplComRoleRescList';
    Vue.regist(SwbTplComRoleRescList);
    import SwbTplComRoleRescAction from './TplComRoleRescAction';
    Vue.regist(SwbTplComRoleRescAction);
    import SwbTplComRoleRescForMobApp from './TplComRoleRescForMobApp';
    Vue.regist(SwbTplComRoleRescForMobApp);

    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "职责权限名称",
                "code": "confName",
                "dataLabel": "text",
                "dataValue": "code",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "目标岗位名称",
                "code": "realName",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "描述",
                "code": "desc",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "移动端角色",
                "code": "mobAppRoleName",
                "basic": true
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-tpl-com-role-list-select',
        desc: '模版岗位选择',
        props: {
            merchantType: {
                type: Number,
                default: null
            },
            radioFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                multipleSelection: [],
                selectTpl: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getDataList();
        },
        methods: {
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.merchantType = self.merchantType;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                merchtAllApi.getTplComRoleList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(this.radioFlag) {
                    let selectTpl = self.selectTpl;
                    if(selectTpl != null) {
                        result.type = 'info';
                        result.data = selectTpl;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择模版岗位！';
                    }
                } else {
                    let multipleSelection = self.multipleSelection;
                    if(multipleSelection != null && multipleSelection.length > 0) {
                        result.type = 'info';
                        result.data = multipleSelection;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择模版岗位！';
                    }
                }
                return result;
            },
            showRoleRescDlg(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "岗位资源（备注：斜体、字体颜色浅的为功能资源，不是菜单！！！）",
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div>' +
                    '<swb-tpl-com-role-resc-list :roleId="roleId" :scopeCode="scopeCode" ref="swb_tpl_com_role_resc_list"></swb-tpl-com-role-resc-list>' +
                    '</div>',
                    data: {
                        roleId: id,
                        scopeCode: 'retailer'
                    }
                });
            },
            showBusinessSetDlg(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "业务 - 设置",
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div>' +
                    '<swb-tpl-com-role-resc-action :roleId="roleId" :scopeCode="scopeCode" ref="swb_tpl_com_role_resc_action"></swb-tpl-com-role-resc-action>' +
                    '</div>',
                    data: {
                        roleId: id,
                        scopeCode: 'retailer'
                    }
                });
            },
            appResc(row){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '移动端资源',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: "关闭",
                    template: '<div class = "">' +
                    '<swb-tpl-com-role-resc-for-mob-app :roleId="roleId" :mobAppRoleCode="mobAppRoleCode" :scopeCode="scopeCode" ref="swb_mob_app_role_resc"></swb-tpl-com-role-resc-for-mob-app>' +
                    '</div>',
                    data: {
                        roleId: row.id,
                        mobAppRoleCode: row.mobAppRoleCode,
                        scopeCode: 'retailer'
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.selectTpl = Utils.merge({}, val);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/TplComRoleListSelect.vue